import { Button } from '@mantine/core';
import React from 'react';

const PopUp = ({ header, opened, onClose, children }) => {
  if (!opened) return null; // Ensure the popup only renders when opened is true

  return (
    <div
      className='
        absolute inset-0 bg-gray-800 bg-opacity-50 flex items-start justify-center pt-20
    '
    >
      <div className='bg-white p-6 rounded shadow-lg max-w-md w-full relative text-left'>
        <div className='space-y-4'>
          <h2 className='text-lg font-bold text-center '>{header}</h2>
          {children}
          <div className='flex justify-end'>
            <Button onClick={onClose} className='bg-purple text-white'>
              Got it!
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
